// Gentle "a new version is available" prompt. Mounted once (in FinanceShell) so
// it watches for deploys on every route. Reload is user-initiated — we never
// yank the page out from under someone who is mid-form.
import { Snackbar, Alert, Button } from '@mui/material';
import { useAppUpdate } from '../hooks/useAppUpdate';

export default function AppUpdateNotice() {
  const updateReady = useAppUpdate();

  return (
    <Snackbar
      open={updateReady}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ mb: { xs: 8, sm: 2 } }} // clear of the mobile menu handle / FAB
    >
      <Alert
        severity="info"
        variant="filled"
        sx={{ alignItems: 'center' }}
        action={
          <Button color="inherit" size="small" variant="outlined"
            onClick={() => window.location.reload()}
            sx={{ borderColor: 'rgba(255,255,255,0.6)', whiteSpace: 'nowrap' }}>
            Refresh
          </Button>
        }
      >
        A new version of EduMIS is available.
      </Alert>
    </Snackbar>
  );
}
